import styled, { css } from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';


export const SectionHeader = styled.h1`
    font-size: 3.5rem;
    font-family: Lato;
    font-weight: 700;
    -webkit-background-clip: text;
    color: transparent;
    letter-spacing: 2px; 
    background-image: linear-gradient(to right bottom,#606c88, #3f4c6b);
     
   

`